const VE = {
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.documentCedulaPlaceholderVe",
      visible: true,
      required: true,
    },
    accountNumber: {
      visible: true,
      required: true,
      label: "bankDetails.accountNumber",
      placeholder: "bankDetails.acountNumberPlaceholderVe",
    },
    swift: {
      visible: true,
      label: "bankDetails.swift",
      placeholder: "bankDetails.swiftMinmaxValidation",
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
    bankName: {
      visible: true,
      label: "bankDetails.bankName",
      required: true,
    },
    IBAN: {
      visible: false,
      required: false,
    },
    ClaveBanco: {
      label: "bankDetails.ClaveBanco",
      visible: true,
      required: true,
    },
  },
};
export { VE };
